import React, { useEffect, useState } from 'react';
import { fetchAccessToken } from './utils/token';
import { getAllStores } from './services/getAllStores';
import { EXPIRY_TIME } from './utils/constants';
import { Toaster } from 'react-hot-toast';
import { ModalProvider } from './context/modalContext';
import { useApp } from './context/appContext';
import { useSearchParams } from 'react-router-dom'; // To read query params
import { fbApiUrl } from "./components/shared/facebooktrack_config";  
import { getAppointmentDetail } from './services/getAppointmentDetail';
import { getStaff } from './services/getStaff';

import MapScreen from './components/MapScreen';
import ListingScreen from './components/ListingScreen';
import DatePickerScreen from './components/DatePickerScreen';
import FormScreen from './components/FormScreen';
import ConfirmationScreen from './components/ConfirmationScreen';
import CancelScreen from './components/CancelScreen';
import LoadingScreen from './components/LoadingScreen';


const App = () => {
  const { currentPage, setCurrentPage, setForm } = useApp();
  const [loading, setLoading] = useState(true);
  const [stores, setStores] = useState([]); // State to store fetched stores data
  const [canceledBookingData, setCanceledBookingData] = useState(null);
  const [searchParams, setSearchParams] = useSearchParams(); // Hook to get query params




  useEffect(() => {
    const sendDataToFacebookAPI = async () => {
        if (!fbApiUrl) {
          console.error("Error: fbApiUrl is not defined!");
        } 
        else {
          try{
        
            const ipResponse = await fetch("https://api64.ipify.org?format=json");
            const ipData = await ipResponse.json();
            const clientIp = ipData.ip; // Extracted IP Address

            // Get User Agent
            const userAgent = navigator.userAgent;

            const data = {
              data: [
                {
                  event_name: "View Booking App",
                  event_time: Math.floor(Date.now() / 1000),
                  event_source_url: window.location.href,
                  user_data: {
                    client_ip_address: clientIp,
                    client_user_agent: userAgent,
                  },
                  action_source: "website",
                },
              ],
              test_event_code: "TEST58912",
            };
          
            const response = await fetch(fbApiUrl, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify(data),
            });
        
            const result = await response.json();
           
          }
          catch (error) {
            console.error("Error sending data to Facebook API:", error);
          }
        }
    };

    sendDataToFacebookAPI();
  }, []); // Runs only on component mount


  
  useEffect(() => {

    const fetchData = async () => {
      try {
        await fetchAccessToken(); // Fetch access token
        const fetchedStores = await getAllStores(); // Fetch all stores
        const filteredStores = fetchedStores.filter(store => store.Brand__c === "Optical Superstore");
        setStores(filteredStores); // Store only filtered stores data
       

        // Check if locationId exists in the query string
        const locationId = searchParams.get('locationId');
        const appointmentId = searchParams.get('appointmentId');

        if (locationId) {
          const validStore = filteredStores.find(store => store.Id === locationId);
          if (validStore) {
            setForm(prevForm => ({
              ...prevForm,
              location: validStore
            }));
            setCurrentPage('date-picker'); // Navigate to date-picker page
          } else {
            // Invalid locationId: Redirect to default page and remove query param
            searchParams.delete('locationId');
            setSearchParams(searchParams);
            setCurrentPage('map');
          }
        }

        if (appointmentId) {

            try {

              await new Promise(resolve => setTimeout(resolve, 500));
              const bookingRes = await getAppointmentDetail(appointmentId)
             
              // Wait 2 seconds after API response
              await new Promise(resolve => setTimeout(resolve, 500));

              // After successful save, update query string
            
              let validStore2 = '';
              let staffName = 'Any'; // default

              if (bookingRes?.locationId) {
                validStore2 = filteredStores.find(store => store.Id === bookingRes.locationId) || '';
              }

              // Try to get staff only if locationId exists
              if (bookingRes?.locationId) {
                const staff = await getStaff(bookingRes.locationId);

                // Only try to find staff name if staffId exists
                if (bookingRes?.staffId && Array.isArray(staff) && staff.length > 0) {
                  const matchedStaff = staff.find(s => s.PIAB__Staff_Member__c === bookingRes.staffId);
                  if (matchedStaff) {
                    staffName = matchedStaff.Staff_Name__c;
                  }
                }
              }




              if (bookingRes.status && bookingRes.status === "Confirmed") {

                const bookingDate = bookingRes.appointmentDate; // e.g. "2025-08-22"
                const bookingEndTime = bookingRes.endTime; // e.g. "10:20:00.000Z"
            
                let isUpcoming = true;
            
                if (bookingDate && bookingEndTime) {
                  // Create a Date object for the booking end
                  const bookingEnd = new Date(`${bookingDate}T${bookingEndTime}`);
                  const now = new Date();
          
                  if (bookingEnd <= now) {
                      isUpcoming = false;
                  }
                }
                    
                
                if(isUpcoming){

                  if (validStore2) {

                    setForm({
                        location: validStore2,
                        date: bookingRes.appointmentDate,
                        time: {
                          status: bookingRes.status,
                          startTimeReadable: bookingRes.startTimeReadable,
                          startTime: bookingRes.startTime,
                          staffId: bookingRes.staffId,
                          shiftId: bookingRes.shiftId,
                          serviceOfferingId: bookingRes.serviceOfferingId,
                          serviceId: bookingRes.serviceId,
                          locationId: bookingRes.locationId,
                          Id: bookingRes.Id,
                          endTimeReadable: bookingRes.endTimeReadable,
                          endTime: bookingRes.endTime,
                          clientId: bookingRes.clientId,
                          appointmentDate: bookingRes.appointmentDate,
                        },
                        testId: bookingRes.serviceId,
                        staffId: bookingRes.staffId,
                        staffName: staffName,
                        appointmentId: bookingRes.Id, // ✅ corrected
                        clientId: bookingRes.clientId,
                        bookingForm: {},
                        prev_appointmentId: bookingRes.appointmentDate,
                        reschedule_data: '1', // ✅ keeps track of reschedule state
                    });
    
                    setCurrentPage("confirmation")

                  } 
                  else {
                    console.error("Booking get failed else:");

                    // Invalid locationId: Redirect to default page and remove query param
                    searchParams.delete('appointmentId');
                    setSearchParams(searchParams);
                    setCurrentPage('map');
                  }

                }
                else{

                    if (validStore2) {
                      console.error("Booking canceled or time is past:");

                      const bookingRes_cancel = {
                        location: validStore2,
                        date: bookingRes.appointmentDate,
                        time: {
                          status: bookingRes.status,
                          startTimeReadable: bookingRes.startTimeReadable,
                          startTime: bookingRes.startTime,
                          staffId: bookingRes.staffId,
                          shiftId: bookingRes.shiftId,
                          serviceOfferingId: bookingRes.serviceOfferingId,
                          serviceId: bookingRes.serviceId,
                          locationId: bookingRes.locationId,
                          Id: bookingRes.Id,
                          endTimeReadable: bookingRes.endTimeReadable,
                          endTime: bookingRes.endTime,
                          clientId: bookingRes.clientId,
                          appointmentDate: bookingRes.appointmentDate,
                        },
                        testId: bookingRes.serviceId,
                        staffId: bookingRes.staffId,
                        staffName: staffName,
                        appointmentId: bookingRes.Id, // ✅ corrected
                        clientId: bookingRes.clientId,
                        bookingForm: {},
                      };

                      setCanceledBookingData(bookingRes_cancel);
                      setCurrentPage('cancel');

                      
                      } 
                    else {
                      console.error("Booking get failed else:");

                      // Invalid locationId: Redirect to default page and remove query param
                      searchParams.delete('appointmentId');
                      setSearchParams(searchParams);
                      setCurrentPage('map');
                    }
                }
                
              }
              else if (bookingRes.status && bookingRes.status === "Cancelled") {

                if (validStore2) {
                  console.error("Booking canceled or time is past:");

                  const bookingRes_cancel = {
                    location: validStore2,
                    date: bookingRes.appointmentDate,
                    time: {
                      status: bookingRes.status,
                      startTimeReadable: bookingRes.startTimeReadable,
                      startTime: bookingRes.startTime,
                      staffId: bookingRes.staffId,
                      shiftId: bookingRes.shiftId,
                      serviceOfferingId: bookingRes.serviceOfferingId,
                      serviceId: bookingRes.serviceId,
                      locationId: bookingRes.locationId,
                      Id: bookingRes.Id,
                      endTimeReadable: bookingRes.endTimeReadable,
                      endTime: bookingRes.endTime,
                      clientId: bookingRes.clientId,
                      appointmentDate: bookingRes.appointmentDate,
                    },
                    testId: bookingRes.serviceId,
                    staffId: bookingRes.staffId,
                    staffName: staffName,
                    appointmentId: bookingRes.Id, // ✅ corrected
                    clientId: bookingRes.clientId,
                    bookingForm: {},
                  };

                  setCanceledBookingData(bookingRes_cancel);
                  setCurrentPage('cancel');

                  
                } 
                else {
                  console.error("Booking get failed else:");

                  // Invalid locationId: Redirect to default page and remove query param
                  searchParams.delete('appointmentId');
                  setSearchParams(searchParams);
                  setCurrentPage('map');
                }

              }
              else{

                console.error("Booking get failed else:");

                searchParams.delete('appointmentId');
                setSearchParams(searchParams);
                setCurrentPage('map');
              }
      
              setLoading(false); 
      
            } catch (error) {
                console.error("Booking get failed:");
               
                searchParams.delete('appointmentId');
                setSearchParams(searchParams);
                setCurrentPage('map');
                setLoading(false);
            }
          

        }
        else {
          // no appointmentId → just finish normally
          setLoading(false);
        }

      } catch (error) {
        console.error('Error fetching data:', error);
        setLoading(false); // Ensure loading is false even in case of an error
        // You can display a toast or show an error screen if needed
      }
    };

    fetchData(); // Trigger the API calls

    const interval = setInterval(fetchAccessToken, EXPIRY_TIME); // Refresh token periodically
    return () => clearInterval(interval);

  }, []); // Empty dependency array ensures this runs only once when the component mounts



  const renderPage = () => {
    if (loading) {
      return <LoadingScreen />; // Show loading screen if data is still being fetched
    }

    switch (currentPage) {
      case 'map':
        return <MapScreen stores={stores} />; // Pass stores to MapScreen
      case 'listing':
        return <ListingScreen stores={stores} />; // Pass stores to ListingScreen
      case 'date-picker':
        return <DatePickerScreen />;
      case 'form':
        return <FormScreen />;
      case 'confirmation':
        return <ConfirmationScreen />;
      case 'cancel':
        return <CancelScreen bookingData={canceledBookingData}/>;
      default:
        return <MapScreen stores={stores} />;
    }
  };

  return (
    <ModalProvider>
      {renderPage()}
      <Toaster position="top-center" toastOptions={{ duration: 3000 }} />
    </ModalProvider>
  );
};

export default App;
